import './style.css';
import App from './App';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const app = new App();
